export default [
  {
    country_code: "AR",
    direction: "right_to_left",
    identifiable: true,
    language: "ar",
    language_name: "Arabic",
    native_language_name: "العربية",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "AZ",
    direction: "right_to_left",
    identifiable: true,
    language: "az",
    language_name: "Azerbaijani",
    native_language_name: "آذربایجان دیلی",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "RU",
    direction: "left_to_right",
    identifiable: true,
    language: "ba",
    language_name: "Bashkir",
    native_language_name: "башҡорт Теле",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "BY",
    direction: "left_to_right",
    identifiable: true,
    language: "be",
    language_name: "Belarusian",
    native_language_name: "Беларуская мова",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "BG",
    direction: "left_to_right",
    identifiable: true,
    language: "bg",
    language_name: "Bulgarian",
    native_language_name: "български език",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "BD",
    direction: "left_to_right",
    identifiable: true,
    language: "bn",
    language_name: "Bengali",
    native_language_name: "বাংলা",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "BA",
    direction: "left_to_right",
    identifiable: false,
    language: "bs",
    language_name: "Bosnian",
    native_language_name: "Bosanski",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "ES",
    direction: "left_to_right",
    identifiable: true,
    language: "ca",
    language_name: "Catalan",
    native_language_name: "Català",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "ME",
    direction: "left_to_right",
    identifiable: false,
    language: "cnr",
    language_name: "Montenegrin",
    native_language_name: "Crnogorski",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "CZ",
    direction: "left_to_right",
    identifiable: true,
    language: "cs",
    language_name: "Czech",
    native_language_name: "Český Jazyk",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "RU",
    direction: "left_to_right",
    identifiable: true,
    language: "cv",
    language_name: "Chuvash",
    native_language_name: "Чӑвашла",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "GB",
    direction: "left_to_right",
    identifiable: true,
    language: "cy",
    language_name: "Welsh",
    native_language_name: "Cymraeg",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "DK",
    direction: "left_to_right",
    identifiable: true,
    language: "da",
    language_name: "Danish",
    native_language_name: "Dansk",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "DE",
    direction: "left_to_right",
    identifiable: true,
    language: "de",
    language_name: "German",
    native_language_name: "Deutsch",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "GR",
    direction: "left_to_right",
    identifiable: true,
    language: "el",
    language_name: "Greek",
    native_language_name: "Νέα Ελληνικά",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "US",
    direction: "left_to_right",
    identifiable: true,
    language: "en",
    language_name: "English",
    native_language_name: "English",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "EO",
    direction: "left_to_right",
    identifiable: true,
    language: "eo",
    language_name: "Esperanto",
    native_language_name: "Esperanto",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "ES",
    direction: "left_to_right",
    identifiable: true,
    language: "es",
    language_name: "Spanish",
    native_language_name: "Español",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "EE",
    direction: "left_to_right",
    identifiable: true,
    language: "et",
    language_name: "Estonian",
    native_language_name: "Eesti Keel",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "ES",
    direction: "left_to_right",
    identifiable: true,
    language: "eu",
    language_name: "Basque",
    native_language_name: "Euskara",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "IR",
    direction: "right_to_left",
    identifiable: true,
    language: "fa",
    language_name: "Persian",
    native_language_name: "فارسی",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "FI",
    direction: "left_to_right",
    identifiable: true,
    language: "fi",
    language_name: "Finnish",
    native_language_name: "Suomen Kieli",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "FR",
    direction: "left_to_right",
    identifiable: true,
    language: "fr",
    language_name: "French",
    native_language_name: "Français",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "CA",
    direction: "left_to_right",
    identifiable: false,
    language: "fr-CA",
    language_name: "French (Canada)",
    native_language_name: "Français Québécois",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "IE",
    direction: "left_to_right",
    identifiable: true,
    language: "ga",
    language_name: "Irish",
    native_language_name: "Gaeilge",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "IN",
    direction: "left_to_right",
    identifiable: true,
    language: "gu",
    language_name: "Gujarati",
    native_language_name: "ગુજરાતી",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "IL",
    direction: "right_to_left",
    identifiable: true,
    language: "he",
    language_name: "Hebrew",
    native_language_name: "עברית",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "IN",
    direction: "left_to_right",
    identifiable: true,
    language: "hi",
    language_name: "Hindi",
    native_language_name: "हिन्दी",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "HR",
    direction: "left_to_right",
    identifiable: true,
    language: "hr",
    language_name: "Croatian",
    native_language_name: "Hrvatski",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "HT",
    direction: "left_to_right",
    identifiable: true,
    language: "ht",
    language_name: "Haitian",
    native_language_name: "Kreyòl Ayisyen",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "HU",
    direction: "left_to_right",
    identifiable: true,
    language: "hu",
    language_name: "Hungarian",
    native_language_name: "Magyar Nyelv",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "AM",
    direction: "left_to_right",
    identifiable: true,
    language: "hy",
    language_name: "Armenian",
    native_language_name: "հայերեն",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "ID",
    direction: "left_to_right",
    identifiable: false,
    language: "id",
    language_name: "Indonesian",
    native_language_name: "Bahasa Indonesia",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "IS",
    direction: "left_to_right",
    identifiable: true,
    language: "is",
    language_name: "Icelandic",
    native_language_name: "Íslenska",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "IT",
    direction: "left_to_right",
    identifiable: true,
    language: "it",
    language_name: "Italian",
    native_language_name: "Italiano",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "JP",
    direction: "left_to_right",
    identifiable: true,
    language: "ja",
    language_name: "Japanese",
    native_language_name: "日本語",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: false,
  },
  {
    country_code: "GE",
    direction: "left_to_right",
    identifiable: true,
    language: "ka",
    language_name: "Georgian",
    native_language_name: "ქართული",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "KZ",
    direction: "left_to_right",
    identifiable: true,
    language: "kk",
    language_name: "Kazakh",
    native_language_name: "қазақ тілі",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "KH",
    direction: "left_to_right",
    identifiable: true,
    language: "km",
    language_name: "Central Khmer",
    native_language_name: "ភាសាខ្មែរ",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "KR",
    direction: "left_to_right",
    identifiable: true,
    language: "ko",
    language_name: "Korean",
    native_language_name: "한국어",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "ku",
    direction: "right_to_left",
    identifiable: true,
    language: "ku",
    language_name: "Kurdish",
    native_language_name: "کوردی",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "KG",
    direction: "left_to_right",
    identifiable: true,
    language: "ky",
    language_name: "Kirghiz",
    native_language_name: "кыргызча",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "LA",
    direction: "left_to_right",
    identifiable: true,
    language: "lo",
    language_name: "Lao",
    native_language_name: "ພາສາລາວ",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "LT",
    direction: "left_to_right",
    identifiable: true,
    language: "lt",
    language_name: "Lithuanian",
    native_language_name: "Lietuvių Kalba",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "LV",
    direction: "left_to_right",
    identifiable: true,
    language: "lv",
    language_name: "Latvian",
    native_language_name: "Latviešu Valoda",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "IN",
    direction: "left_to_right",
    identifiable: true,
    language: "ml",
    language_name: "Malayalam",
    native_language_name: "മലയാളം",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "MN",
    direction: "left_to_right",
    identifiable: true,
    language: "mn",
    language_name: "Mongolian",
    native_language_name: "Монгол Хэл",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "IN",
    direction: "left_to_right",
    identifiable: true,
    language: "mr",
    language_name: "Marathi",
    native_language_name: "मराठी",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "MY",
    direction: "left_to_right",
    identifiable: true,
    language: "ms",
    language_name: "Malay",
    native_language_name: "Bahasa Melayu",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "MT",
    direction: "left_to_right",
    identifiable: true,
    language: "mt",
    language_name: "Maltese",
    native_language_name: "Malti",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "MM",
    direction: "left_to_right",
    identifiable: true,
    language: "my",
    language_name: "Burmese",
    native_language_name: "မြန်မာစာ",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "NO",
    direction: "left_to_right",
    identifiable: true,
    language: "nb",
    language_name: "Norwegian Bokmal",
    native_language_name: "Bokmål",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "NP",
    direction: "left_to_right",
    identifiable: true,
    language: "ne",
    language_name: "Nepali",
    native_language_name: "नेपाली भाषा",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "NL",
    direction: "left_to_right",
    identifiable: true,
    language: "nl",
    language_name: "Dutch",
    native_language_name: "Nederlands",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "NO",
    direction: "left_to_right",
    identifiable: true,
    language: "nn",
    language_name: "Norwegian Nynorsk",
    native_language_name: "Nynorsk",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "IN",
    direction: "left_to_right",
    identifiable: true,
    language: "pa",
    language_name: "Punjabi",
    native_language_name: "ਪੰਜਾਬੀ",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "PK",
    direction: "right_to_left",
    identifiable: true,
    language: "pa-PK",
    language_name: "Punjabi (Shahmukhi script, Pakistan)",
    native_language_name: "پنجابی",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "PL",
    direction: "left_to_right",
    identifiable: true,
    language: "pl",
    language_name: "Polish",
    native_language_name: "Język polski",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "PS",
    direction: "right_to_left",
    identifiable: true,
    language: "ps",
    language_name: "Pushto",
    native_language_name: "پښتو",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "BR",
    direction: "left_to_right",
    identifiable: true,
    language: "pt",
    language_name: "Portuguese",
    native_language_name: "Português",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "RO",
    direction: "left_to_right",
    identifiable: true,
    language: "ro",
    language_name: "Romanian",
    native_language_name: "Limba Română",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "RU",
    direction: "left_to_right",
    identifiable: true,
    language: "ru",
    language_name: "Russian",
    native_language_name: "Русский язык",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "LK",
    direction: "left_to_right",
    identifiable: true,
    language: "si",
    language_name: "Sinhala",
    native_language_name: "සිංහල",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "SK",
    direction: "left_to_right",
    identifiable: true,
    language: "sk",
    language_name: "Slovakian",
    native_language_name: "Slovenčina",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "SI",
    direction: "left_to_right",
    identifiable: true,
    language: "sl",
    language_name: "Slovenian",
    native_language_name: "Slovenščina",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "SO",
    direction: "right_to_left",
    identifiable: true,
    language: "so",
    language_name: "Somali",
    native_language_name: "اللغة الصومالية",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "AL",
    direction: "left_to_right",
    identifiable: true,
    language: "sq",
    language_name: "Albanian",
    native_language_name: "Shqip",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "RS",
    direction: "left_to_right",
    identifiable: true,
    language: "sr",
    language_name: "Serbian",
    native_language_name: "Српски",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "SE",
    direction: "left_to_right",
    identifiable: true,
    language: "sv",
    language_name: "Swedish",
    native_language_name: "Svenska",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "IN",
    direction: "left_to_right",
    identifiable: true,
    language: "ta",
    language_name: "Tamil",
    native_language_name: "தமிழ்",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "IN",
    direction: "left_to_right",
    identifiable: true,
    language: "te",
    language_name: "Telugu",
    native_language_name: "తెలుగు",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "TH",
    direction: "left_to_right",
    identifiable: true,
    language: "th",
    language_name: "Thai",
    native_language_name: "ภาษาไทย",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: false,
  },
  {
    country_code: "PH",
    direction: "left_to_right",
    identifiable: true,
    language: "tl",
    language_name: "Tagalog",
    native_language_name: "ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔",
    supported_as_source: false,
    supported_as_target: false,
    words_separated: true,
  },
  {
    country_code: "TR",
    direction: "left_to_right",
    identifiable: true,
    language: "tr",
    language_name: "Turkish",
    native_language_name: "Türkçe",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "UA",
    direction: "left_to_right",
    identifiable: true,
    language: "uk",
    language_name: "Ukrainian",
    native_language_name: "Українська мова",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "PK",
    direction: "right_to_left",
    identifiable: true,
    language: "ur",
    language_name: "Urdu",
    native_language_name: "اُردُو",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "VN",
    direction: "left_to_right",
    identifiable: true,
    language: "vi",
    language_name: "Vietnamese",
    native_language_name: "Tiếng Việt",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: true,
  },
  {
    country_code: "CN",
    direction: "left_to_right",
    identifiable: true,
    language: "zh",
    language_name: "Simplified Chinese",
    native_language_name: "中文",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: false,
  },
  {
    country_code: "TW",
    direction: "left_to_right",
    identifiable: true,
    language: "zh-TW",
    language_name: "Traditional Chinese",
    native_language_name: "古文",
    supported_as_source: true,
    supported_as_target: true,
    words_separated: false,
  },
];
